module.exports = __webpack_public_path__ + "static/media/edit.a8ff3a0d.svg";